import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/tanggal-merah/$year")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: `/en/red-dates/${params.year}` } as any);
  },
  component: () => null,
});
